

    const container = document.getElementById('map_container');
    const params = location.search.split(/[?&]/).map(function(e) {
        if (e.length) {
            return e.split('=');
        }
        return [];
    }).filter(function(e) {
        return (e && e.length === 2);
    });
    const options = {};
    params.forEach(function(item) {
        options[item[0]] = item[1];
    });

    if (!options.emmid) {
        location.href = location.href
        + (location.href.indexOf('?') > -1 ? '&' : '?')
        + 'emmid=' + prompt('emmid');
    }
    const livemap = window.wemap.v1.createLivemap(container, options, false);
    await livemap.waitForReady();
    const SERVER_URL = 'https://navigation-logger.thibaud-michel.com';

    const startButton = document.getElementById('start');
    const stopButton = document.getElementById('stop');

    startButton.addEventListener('click', () => {
        window.NavigationLogger.start(SERVER_URL, { extraConfig: {isLivemap: true, emmid: options.emmid}});
        startButton.disabled = true;
        stopButton.disabled = false;
    });

    stopButton.addEventListener('click', () => {
        window.NavigationLogger.stop();
        startButton.disabled = false;
        stopButton.disabled = true;
    });
  